import { queryOptions, skipToken } from '@tanstack/react-query';
import { QueryKey } from 'core/react-query/queryClient';
import { getMemo } from 'networking/mindfeed/services/memo.service';
import type { MemoId } from 'models/Memo';

// One memo by id (the memos list is memosQuery). No id: defined, never runs.
export const memoQuery = (id?: MemoId) =>
  queryOptions({
    queryKey: [QueryKey.MEMOS, id],
    queryFn: id ? () => getMemo(id) : skipToken,
  });
